var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: 0,
    y: 0,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 15,
    r: 6,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 6 ;0 3 ; 0 1;0 -2;0 -8;0 -8;0 0; 0 6"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 6,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: 0.5,
    dur: "1s",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 6 ;0 3 ; 0 1;0 -2;0 -8;0 -8;0 0; 0 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a6b09a0d321c41ffa766c8c409e43764.svg";
export { ForwardRef as ReactComponent };